// src/components/ContactForm.js
import React, { useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import { client } from "../sanity/client"; // still used for fetching car titles only
import { useLocation } from "react-router-dom";

export default function ContactForm() {
  const [cars, setCars] = useState([]);
  const [messageType, setMessageType] = useState("");
  const [selectedCar, setSelectedCar] = useState("");
  const [message, setMessage] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const location = useLocation();

  useEffect(() => {
    const query = `*[_type == "car"]{_id, title}`;
    client
      .fetch(query)
      .then((data) => {
        setCars(data);
      })
      .catch((err) => console.error("❌ Sanity fetch error:", err));
  }, []);

  // Pre-select car if passed as query param (?car=Car Title)
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const preselectedCarTitle = queryParams.get("car");

    if (preselectedCarTitle) {
      setMessageType("buy");
      // Find the car _id matching the title, if available
      const matchingCar = cars.find(
        (car) => car.title.toLowerCase() === preselectedCarTitle.toLowerCase()
      );

      if (matchingCar) {
        setSelectedCar(matchingCar._id);
      } else {
        // If not found by title, just clear selection or leave as is
        setSelectedCar("");
      }
    }
  }, [location.search, cars]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      name,
      email,
      messageType,
      message,
      selectedCar:
        messageType === "buy"
          ? cars.find((car) => car._id === selectedCar)?.title || "N/A"
          : "N/A",
    };

    emailjs
      .send("service_gl3yhyr", "template_56s8slq", templateParams, "heuY3m4oXHIcIFeQ5")
      .then(
        () => {
          alert("Message sent successfully!");
          setName("");
          setEmail("");
          setMessageType("");
          setSelectedCar("");
          setMessage("");
        },
        (error) => {
          console.error("EmailJS error:", error);
          alert("Something went wrong. Please try again.");
        }
      );
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="max-w-lg mx-auto p-6 bg-white rounded shadow font-open"
    >
      <label className="block mb-4">
        <span className="font-semibold text-lg">Name</span>
        <input
          type="text"
          className="w-full mt-1 p-3 border rounded text-lg"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          placeholder="Your full name"
        />
      </label>

      <label className="block mb-4">
        <span className="font-semibold text-lg">Email</span>
        <input
          type="email"
          className="w-full mt-1 p-3 border rounded text-lg"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          placeholder="you@example.com"
        />
      </label>

      <label className="block mb-4">
        <span className="font-semibold text-lg">Reason for Contact</span>
        <select
          className="w-full mt-1 p-3 border rounded text-lg"
          value={messageType}
          onChange={(e) => setMessageType(e.target.value)}
          required
        >
          <option value="" disabled>
            Select an option
          </option>
          <option value="general">General Question</option>
          <option value="service">Service Inquiry</option>
          <option value="buy">Interested in Buying a Car</option>
          <option value="other">Other</option>
        </select>
      </label>

      {messageType === "buy" && (
        <label className="block mb-4">
          <span className="font-semibold text-lg">Select a Car</span>
          <select
            className="w-full mt-1 p-3 border rounded text-lg"
            value={selectedCar}
            onChange={(e) => setSelectedCar(e.target.value)}
            required
          >
            <option value="" disabled>
              Choose a car
            </option>
            {cars.map((car) => (
              <option key={car._id} value={car._id}>
                {car.title}
              </option>
            ))}
          </select>
        </label>
      )}

      <label className="block mb-6">
        <span className="font-semibold text-lg">Message</span>
        <textarea
          className="w-full mt-1 p-3 border rounded text-lg"
          rows="5"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
          placeholder="Write your message here"
        />
      </label>

      <button
        type="submit"
        className="bg-primary text-white py-3 px-6 rounded font-bold hover:bg-primary/90 transition"
      >
        Send Message
      </button>
    </form>
  );
}
